import { useContext } from 'react';
import { Card, StyledBody } from 'baseui/card';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { HeadingSmall, ParagraphSmall } from 'baseui/typography';
import { DateTime } from 'luxon';
import { NPRequestStatus } from '@gtintel/platform-types';
import { COLOURS, convertCurrencySymbolToCode, formatPrice, getMarginTagColor } from '@gtintel/platform-utils';
import { ProjectContext, RequestEditorContext } from '../../context';
import { calculateTotalCost } from '../utils';
export const AssignmentInfoCards = ({
  projectMargin
}) => {
  const {
    fee,
    status
  } = useContext(RequestEditorContext);
  const {
    netPrice,
    currency,
    requestedCompletionDate,
    assignmentCosts
  } = useContext(ProjectContext);
  const currencyCode = convertCurrencySymbolToCode(currency());
  const marginFee = status() === NPRequestStatus.Draft ? 0 : +fee();
  const adjustedAssignmentCost = assignmentCosts() - marginFee;
  const totalCost = calculateTotalCost(status(), adjustedAssignmentCost, +fee());
  return <FlexGrid flexGridColumnCount={3} flexGridColumnGap="scale400" marginBottom="scale600">
      <FlexGridItem>
        <Card overrides={{
        Root: {
          style: {
            borderTopWidth: '4px',
            borderTopStyle: 'solid',
            borderTopColor: COLOURS.gray
          }
        }
      }}>
          <StyledBody>
            <ParagraphSmall margin="0">Client Due Date</ParagraphSmall>
            <HeadingSmall margin="0">
              {DateTime.fromISO(requestedCompletionDate()).toLocaleString()}
            </HeadingSmall>
          </StyledBody>
        </Card>
      </FlexGridItem>
      <FlexGridItem>
        <Card overrides={{
        Root: {
          style: {
            borderTopWidth: '4px',
            borderTopStyle: 'solid',
            borderTopColor: getMarginTagColor(projectMargin)
          }
        }
      }}>
          <StyledBody>
            <ParagraphSmall margin="0">
              Client Fee (after discount)
            </ParagraphSmall>
            <HeadingSmall margin="0">
              {formatPrice(+netPrice(), currencyCode)}
            </HeadingSmall>
          </StyledBody>
        </Card>
      </FlexGridItem>
      <FlexGridItem>
        <Card overrides={{
        Root: {
          style: {
            borderTopWidth: '4px',
            borderTopStyle: 'solid',
            borderTopColor: getMarginTagColor(projectMargin)
          }
        }
      }}>
          <StyledBody>
            <ParagraphSmall margin="0">
              Assignment Fees (including this)
            </ParagraphSmall>
            <HeadingSmall margin="0">
              {formatPrice(totalCost, currencyCode)}
            </HeadingSmall>
          </StyledBody>
        </Card>
      </FlexGridItem>
    </FlexGrid>;
};